var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleAuthenticator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0007 32.083V44.9163L10.1032 44.8714C6.57242 44.8714 3.70898 42.0096 3.70898 38.4772C3.70898 34.9464 6.57242 32.083 10.1032 32.083H39.0007Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9948 16.6836C17.2286 13.6245 18.2762 9.71512 21.3353 7.94894C24.3945 6.18275 28.3038 7.23027 30.07 10.2894L44.5572 35.292L33.4436 41.7086L18.9948 16.6836Z",
    fill: "#FBC02D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8977 44.872C71.4285 44.8672 74.2919 42.0102 74.2919 38.4778C74.2919 34.9455 71.4285 32.0836 67.8977 32.0836H50.0947L58.9673 16.6612C60.7287 13.6004 59.686 9.69266 56.6268 7.92647C53.5677 6.16029 49.6583 7.20781 47.8921 10.267L39.0035 25.6621L32.6895 41.7263L50.1171 44.9009L67.8977 44.872Z",
    fill: "#1E88E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6628 69.0597C53.6149 70.8243 49.7007 69.7655 47.9361 66.7176L39.017 51.3176L30.1139 66.7337C28.3493 69.7976 24.4351 70.8403 21.3711 69.0757C18.3232 67.3112 17.2805 63.397 19.0291 60.333L27.9001 44.917H50.1178L59.0049 60.317C60.7695 63.3809 59.7268 67.2791 56.6628 69.0597Z",
    fill: "#E53935"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1161 44.9164H27.8984L38.9832 25.6504L50.1161 44.9164Z",
    fill: "#1565C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAuthenticator);
export default __webpack_public_path__ + "static/media/google_authenticator.896c0fb464e706979cad14859d66c4b5.svg";
export { ForwardRef as ReactComponent };